import Template from './Template';

export default class TemplateForm {
  constructor(id = null, name = '', sets = [], primaryStatus = null, statuses = []) {
    this.id = id;
    this.name = name;
    this.sets = sets;
    this.primaryStatus = primaryStatus;
    this.statuses = statuses;
  }

  constructSets(data) {
    const mockData = [...data];
    let sets = [];
    const setArray = [];
    for(let i = mockData.length - 1; i >= 0; i--) {
      if(mockData[i].type.match('^(warmup|set|cooldown)$')) {
        setArray.push(mockData.splice(i));
      }
    }

    for(let i = 0; i < setArray.length; i++) {
      const setObj = setArray[i];
      const setThingy = {activities: []};
      for(let j = 0; j < setObj.length; j++) {
        const innerObj = setObj[j];
        if(innerObj.type.match('^(warmup|set|cooldown)$')) {
          setThingy['set_name'] = innerObj.name;
          setThingy['set_type'] = innerObj.type;
          setThingy['sets'] = innerObj.value;
        } else {
          setThingy['activities'].push({
            activity_type: innerObj.type,
            duration: innerObj.value,
            exercise: innerObj.exercise,
          });
        }
      }
      sets.push(setThingy);
    }
    return sets.reverse();
  }

  destructSets(data) {
    let template = [];
    for(let i = 0; i < data.length; i++) {
      const setObj = data[i];
      template.push({name: setObj.set_name, type: setObj.set_type, value: setObj.sets})
      const activities = setObj["activities"];
      for(let j = 0; j < activities.length; j++) {
        const activityObj = activities[j];
        template.push({type: activityObj.activity_type, value: activityObj.duration, exercise: activityObj.exercise ? activityObj.exercise : null})
      }
    }
    return template;
  }

  formatforDB() {
    const data = {
      id: this.id,
      name: this.name,
      sets: this.constructSets(this.sets),
    }

    return new Template(
      data.id,
      data.name,
      data.sets,
    );
  }

  formatForForm(obj) {
    const template = new Template();
    if(obj) {
      for (const key in template) {
        if (obj.hasOwnProperty(key)) {
          template[key] = obj[key];
        }
      }
    }

    this.id = template.id;
    this.name = template.name;
    this.sets = this.destructSets(template.sets);

    this.checkValidity();
  }

  getExerciseIds() {
    const exIds = [];
    for(let i = 0; i < this.sets.length; i++) {
      const item = this.sets[i];
      if(item.type === "reps" || item.type === "timed" ) {
        if(item.exercise) {
          exIds.push(item.exercise.id);
        }
      }
    }
    return exIds;
  }

  checkValidity() {
    let primaryStatus = 'Valid';
    let statusList = {};

    if(this.name !== '') {
      statusList.name = {value: true, text: 'Template has a name'};
    } else {
      primaryStatus = 'Invalid';
      statusList.name = {value: false, text: 'Template is missing a name'};
    }

    // if(this.classes.length > 0) {
    //   statusList.classes = {value: true, text: 'Playbook has at least one class'};
    // } else {
    //   primaryStatus = 'Invalid';
    //   statusList.classes = {value: false, text: 'Playbook needs at least one class'};
    // }

    this.primaryStatus = primaryStatus;
    this.statuses = statusList;
  }
}
